<script>
    // your script goes here
    let cls = 'sui-grid'

    export let columns = 0;
    export let gap = 0
</script>

<style lang="less">
    @import './grid.less';
</style>


<div role="grid" class={cls} style:--grid-columns={columns} style:--grid-gap={`${gap}px`} >
    <slot></slot>
</div>